import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import API from '../services/api';
import '../styles/Auth.css';          // ↓ we’ll extend this file for colours (see end)

export default function ForgotPassword() {
  /* ------------ steps ------------ */
  // 1 → ask e-mail     ·   2 → OTP + new pwd
  const [step, setStep] = useState(1);

  /* ------------ form data -------- */
  const [email,    setEmail]    = useState('');
  const [otp,      setOtp]      = useState('');
  const [password, setPassword] = useState('');
  const [loading,  setLoading]  = useState(false);

  /* ------------ status bar ------- */
  const [msg,      setMsg]      = useState('');
  const [msgType,  setMsgType]  = useState('success'); // success | error

  const nav = useNavigate();

  /* ------------ helpers ---------- */
  const show = (text, type='success') => {
    setMsg(text);            // message text
    setMsgType(type);        // colour
  };

  /* ------------ API handlers ----- */
  const requestOtp = async e => {
    e.preventDefault();
    setLoading(true);
    setMsg('');
    try {
      await API.post('/auth/forgot-password', { email });
      show('We’ve e-mailed a 6-digit verification code to you.');
      setStep(2);
    } catch (err) {
      show(err.response?.data?.msg || err.message, 'error');
    } finally { setLoading(false); }
  };

  const resetPwd = async e => {
    e.preventDefault();
    setLoading(true);
    setMsg('');
    try {
      await API.post('/auth/reset-password', { email, otp, password });
      show('Password changed! Redirecting to log-in…');
      setTimeout(() => nav('/login'), 1800);
    } catch (err) {
      show(err.response?.data?.msg || err.message, 'error');
    } finally { setLoading(false); }
  };

  /* ------------ UI --------------- */
  return (
    <div className="auth-container">
      <h2>🔑 Password Reset</h2>

      {/* status bar */}
      {msg && (
        <div className={`status-bar ${msgType}`}>
          {msg}
        </div>
      )}

      {step === 1 && (
        <form onSubmit={requestOtp}>
          <div className="form-group">
            <label>Registered e-mail address</label>
            <input
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              required
            />
          </div>

          <button type="submit" disabled={loading}>
            {loading ? 'Sending…' : 'Send OTP'}
          </button>
        </form>
      )}

      {step === 2 && (
        <form onSubmit={resetPwd}>
          <div className="form-group">
            <label>6-digit verification code</label>
            <input
              type="text"
              value={otp}
              maxLength={6}
              onChange={e => setOtp(e.target.value)}
              required
            />
          </div>

          <div className="form-group">
            <label>New password</label>
            <input
              type="password"
              value={password}
              minLength={6}
              onChange={e => setPassword(e.target.value)}
              required
            />
          </div>

          <button type="submit" disabled={loading}>
            {loading ? 'Updating…' : 'Set New Password'}
          </button>
        </form>
      )}

      <div className="footer-text" style={{ marginTop: 8 }}>
        <Link to="/login">← Back to log-in</Link>
      </div>
    </div>
  );
}
